import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _objectWithoutProperties from "/app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _toConsumableArray from "/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _objectSpread from "/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
var _excluded = ["valid"];
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import axios from "axios";
import { request } from "@/js/http/http_request.js";
import { isAddressNotLimited } from "@/js/http/auth.js";
import { getErrorData, handleErrorData, ERROR_DATA, filterVAutocomplete } from "@/js/forms.js";
import { formRules } from "@/js/form_rules.js";
import Confirm from "@/components/modal/ConfirmationDialog.vue";
import ErrorModal from "@/components/modal/ErrorModal.vue";
var defaultEntityAddForm = {
  fromWarehouseId: null,
  toWarehouseId: 0,
  reference: null,
  comment: "",
  valid: false
};
export default {
  name: "WarehouseStockTransferModal",
  components: {
    Confirm: Confirm,
    ErrorModal: ErrorModal
  },
  props: {
    loggedUserData: Object,
    warehouses: Array
  },
  data: function data() {
    return {
      dialog: false,
      warehousesAvailable: [],
      addingEntity: {
        form: _objectSpread({}, defaultEntityAddForm),
        isPending: false,
        cancellationToken: null
      },
      formRules: formRules,
      ERROR_DATA: ERROR_DATA
    };
  },
  computed: {
    isAnyActionInProgress: function isAnyActionInProgress() {
      return this.addingEntity.isPending;
    }
  },
  created: function created() {
    var _this2 = this;
    this.warehousesAvailable = _toConsumableArray(this.warehouses.filter(function (x) {
      var _x$address, _x$address2;
      return isAddressNotLimited(_this2.loggedUserData, (_x$address = x.address) === null || _x$address === void 0 || (_x$address = _x$address.country) === null || _x$address === void 0 ? void 0 : _x$address.id_country, (_x$address2 = x.address) === null || _x$address2 === void 0 || (_x$address2 = _x$address2.state) === null || _x$address2 === void 0 ? void 0 : _x$address2.id_state);
    }));
  },
  methods: {
    saveNewEntity: function saveNewEntity() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var _this3$addingEntity$c;
        var _this, _this3$addingEntity$f, valid, withoutValid;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this3.addingEntity.isPending = true;
              (_this3$addingEntity$c = _this3.addingEntity.cancellationToken) === null || _this3$addingEntity$c === void 0 || _this3$addingEntity$c.cancel();
              _this3.addingEntity.cancellationToken = axios.CancelToken.source();
              _this = _this3;
              _this3$addingEntity$f = _this3.addingEntity.form, valid = _this3$addingEntity$f.valid, withoutValid = _objectWithoutProperties(_this3$addingEntity$f, _excluded);
              _context2.next = 7;
              return request("/v1/stocks/warehouse-transfer", "post", withoutValid, true, "api", null, _this.addingEntity.cancellationToken).catch(/*#__PURE__*/function () {
                var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(e) {
                  var errorData;
                  return _regeneratorRuntime().wrap(function _callee$(_context) {
                    while (1) switch (_context.prev = _context.next) {
                      case 0:
                        if (!axios.isCancel(e)) {
                          _this.addingEntity.isPending = false;
                          _this.addingEntity.cancellationToken = null;
                          errorData = getErrorData(e, {}, "Unable to create the transfer.", true);
                          handleErrorData(_this, errorData);
                        }
                        throw e;
                      case 2:
                      case "end":
                        return _context.stop();
                    }
                  }, _callee);
                }));
                return function (_x) {
                  return _ref.apply(this, arguments);
                };
              }());
            case 7:
              _this3.addingEntity.isPending = false;
              _this3.addingEntity.cancellationToken = null;
              _this3.$emit("entityCreated");
              _this3.close();
              _this3.$toasted.show("New part created", {
                type: "success"
              });
            case 12:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    open: function open() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _this4.dialog = true;
              return _context3.abrupt("return", new Promise(function (resolve, reject) {
                _this4.resolve = resolve;
                _this4.reject = reject;
              }));
            case 2:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    close: function close() {
      if (!this.isAnyActionInProgress) {
        this.dialog = false;
        this.$emit("closed");
      }
    },
    filterVAutocomplete: filterVAutocomplete
  }
};